import type { ExtendedOptions } from '@cdc-internal/fe-toolbox/libs/fetcher'

import { equityMarketDataFetcher } from '@/libs/fetcher/presets'
import { StockAssetPreview } from '@/types/stock'

export const fetchAllAssets = (options?: ExtendedOptions) =>
  equityMarketDataFetcher<StockAssetPreview[]>(
    '/assets-preview',
    undefined,
    options as ExtendedOptions<StockAssetPreview[]>,
  )
